import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PostState } from '../../state/states/post.state';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import * as fromRoot from '../../../state';
import { takeUntil } from 'rxjs/operators';
import * as homeActions from '../../state/actions/post.action';
import { Router } from '@angular/router';
import { PostPaginationModel } from '../../../shared/data/models/post-pagination.model';
import { VotePostInput } from '../../../shared/data/inputs/vote-post.input';
import { PostInput } from '../../../shared/data/inputs/post.input';
import { NewPostMutationInput } from '../../../shared/data/inputs/new-post-mutation.input';
import { CreateCommentMutationInput } from '../../../shared/data/inputs/create-comment-mutation.input';
import { VoteCommentInput } from '../../../shared/data/inputs/vote-comment.input';
import { GetPostCommentsQueryInput } from '../../../shared/data/inputs/get-post-comments-query.input';
import { CommentPostInput } from '../../../shared/data/inputs/comment-post.input';
import { CastPollVoteInput } from '../../../shared/data/inputs/cast-poll-vote.input';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { GroupModel } from '../../../shared/data/models/group.model';

@Component({
  selector: 'anms-social-post-content',
  templateUrl: './social-post-content.component.html',
  styleUrls: ['./social-post-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialPostContentComponent implements OnInit, OnDestroy {
  @Output() postScroll = new EventEmitter();

  @Input() currentGroup: GroupModel;

  postsState$: Observable<PostState[]>;
  postStateLoading$: Observable<boolean>;
  postStateErrors$: Observable<string>;
  postPagination$: Observable<PostPaginationModel>;

  currentUser: MiniUserModel;

  subscribed$ = new Subject<any>();

  constructor(private store$: Store<fromHome.State>, private router: Router) {}

  ngOnInit(): void {
    this.postsState$ = this.store$.select(fromHome.getPostsState);

    this.store$
      .select(fromRoot.getMe)
      .pipe(takeUntil(this.subscribed$))
      .subscribe(c => (this.currentUser = c));

    this.postStateLoading$ = this.store$.select(fromHome.getPostsLoading);
    this.postStateErrors$ = this.store$.select(fromHome.getPostsError);
    this.postPagination$ = this.store$.select(fromHome.getPostPagination);
  }

  trackByFn(index, item: PostState) {
    return item?.post?.lastEdited || index;
  }

  onScroll(): void {
    if (this.currentUser) {
      // this.store$.dispatch(
      //   new homeActions.LoadMoreTimeline({
      //     topic: 'GENERAL'
      //   })
      // );
      this.postScroll.emit();
    }
  }

  // post operations

  upVotePost(input: VotePostInput): void {
    this.store$.dispatch(new homeActions.UpVotePost(input));
  }

  downVotePost(input: VotePostInput): void {
    this.store$.dispatch(new homeActions.DownVotePost(input));
  }

  unVotePost(input: VotePostInput): void {
    this.store$.dispatch(new homeActions.UnVotePost(input));
  }

  deletePost(input: PostInput): void {
    this.store$.dispatch(new homeActions.DeletePost(input));
  }

  echoPost(input: NewPostMutationInput): void {
    const showOnFeed = this.router.url === '/home';
    if (this.currentGroup) {
      const d: NewPostMutationInput = {
        ...input,
        privateResourceName: 'GROUP',
        privateResourceID: this.currentGroup?.ID
      };
      this.store$.dispatch(
        new homeActions.CreateEchoPost({
          input: d,
          showOnFeed: true
        })
      );
    } else {
      this.store$.dispatch(
        new homeActions.CreateEchoPost({
          input,
          showOnFeed
        })
      );
    }
  }

  // comments parts

  createComment(comment: CreateCommentMutationInput): void {
    this.store$.dispatch(new homeActions.CreateComment(comment));
  }

  upVoteComment(input: VoteCommentInput): void {
    this.store$.dispatch(new homeActions.UpVoteComment(input));
  }

  downVoteComment(input: VoteCommentInput): void {
    this.store$.dispatch(new homeActions.DownVoteComment(input));
  }

  showComments(input: GetPostCommentsQueryInput): void {
    this.store$.dispatch(new homeActions.ShowComments(input));
  }

  hideComments(postId: string): void {
    this.store$.dispatch(new homeActions.HideComments(postId));
  }

  loadMoreComments(input: GetPostCommentsQueryInput): void {
    this.store$.dispatch(new homeActions.LoadMoreComment(input));
  }

  deleteComment(input: CommentPostInput): void {
    this.store$.dispatch(new homeActions.DeleteComment(input));
  }

  favouritePost(input: PostInput): void {
    this.store$.dispatch(new homeActions.FavoritePost(input));
  }

  unFavouritePost(input: PostInput): void {
    this.store$.dispatch(new homeActions.UnFavoritePost(input));
  }

  castForPoll(input: CastPollVoteInput): void {
    this.store$.dispatch(new homeActions.VotePostPoll(input));
  }

  ngOnDestroy(): void {
    this.subscribed$.next();
    this.subscribed$.complete();
  }
}
